import { createAction } from '@reduxjs/toolkit';

export const resetFilters = createAction('resetAllFilters');
export const resetWorkspace = createAction('resetWorkspace');
